import { useEffect, useState } from "react";
import { Resizable } from 're-resizable';
import axios from "axios";
import { BASEURL } from '../../../../../constants';
import { CrossSVG, AddImageSVG, PlusSVG } from "../../../../Icons/icons";
import { closestCenter, DndContext } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { TopicSortableItem } from "../SortableItem/TopicSortableItem";
import QuestionEditor from "../Editor_Component/QuestionEditor";
import { v4 as uuidv4 } from "uuid";

const McqComponent = ({ setImagesArray,
    slideId, contentId, data, isSorted, setIsDataSaved, imagesArray, setCurrentSlideData }) => {
    //isSorted is toggled when there is a sort opration, isSorted is required because McqComponent was not setting the data from the parent after the sort happend 

    const [mcq, setMcq] = useState(null);

    useEffect(() => {

        async function fetchOptionImageUrl(data) {
            const imagesPromiseArray = []
            const indexArray = []

            data.options.forEach(async (optionObject, index) => {

                if (optionObject.imageKey) {
                    const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
                        params: {
                            imageId: optionObject.imageKey,
                            index: index
                        }
                    })
                    imagesPromiseArray.push(imagePromise)
                    indexArray.push(index)
                }

            })

            const promiseResponse = await Promise.all(imagesPromiseArray)
            promiseResponse.map((resObj, index) => {
                // { options : [ { image: url }]}
                const replaceIndex = indexArray[index]
                data.options[replaceIndex] = { ...data.options[replaceIndex], image: resObj.data.dataUrl }
            })


            setMcq(data);
        }
        if (data) {

            fetchOptionImageUrl(data)

        } else {

            setMcq({
                question: '',
                // options: ['', '', '', ''],
                options: [{ id: 1, text: "", image: null, imageKey: "" }, { id: 2, text: "", image: null, imageKey: "" }, { id: 3, text: "", image: null, imageKey: "" }, { id: 4, text: "", image: null, imageKey: "" }],
                correctAnswer: [],
                type: 'single',
                imageData: { image: '', width: '400px', height: '' }
            });
        }
    }, []);



    useEffect(() => {
        setCurrentSlideData((currentSlide) => {
            const newContent = currentSlide.content.map((contentObj) => {
                if (contentId === contentObj.id) {
                    return {
                        ...contentObj, data: mcq
                    }
                } else {
                    return {
                        ...contentObj
                    }
                }
            })
            return { ...currentSlide, content: newContent }
        })

    }, [mcq])



    function updateQuestion(e) {
        setMcq({ ...mcq, question: e.target.value });
        setIsDataSaved(false);
    }

    function saveCorrectAnswer(e, optionIndex) {
        if (mcq.type === 'single') {
            const newCorrectAnswer = { ...mcq.correctAnswer };//new obj option0 option1

            newCorrectAnswer[`${optionIndex}`] = true;

            for (let option in newCorrectAnswer) {
                if (option !== `${optionIndex}`) {

                    newCorrectAnswer[option] = false; //one word takes 2 hours to debug 
                }

            }

            setMcq({ ...mcq, correctAnswer: newCorrectAnswer });
        }
        if (mcq.type === "multiple") {
            if (e.target.checked) {
                const newCorrectAnswer = { ...mcq.correctAnswer };
                newCorrectAnswer[`${optionIndex}`] = true;
                setMcq({ ...mcq, correctAnswer: newCorrectAnswer });
            } else {
                const newCorrectAnswer = { ...mcq.correctAnswer };
                newCorrectAnswer[`${optionIndex}`] = false;
                setMcq({ ...mcq, correctAnswer: newCorrectAnswer });
            }
        }
        setIsDataSaved(false);
    }

    function saveOption(e, optionIndex) {
        // const newMcq = { ...mcq };
        // newMcq.options[optionIndex] = e.target.value;
        // const newCorrectAnswer = { ...newMcq.correctAnswer }
        // if (!e.target.value) {
        //     newCorrectAnswer[`${optionIndex}`] = false;

        // }
        // newMcq.correctAnswer = newCorrectAnswer;
        const updatedOptions = [...mcq.options];
        updatedOptions[optionIndex] = { ...updatedOptions[optionIndex], text: e.target.value };

        setMcq({
            ...mcq,
            options: updatedOptions,
        });
        // setMcq(newMcq);
        setIsDataSaved(false);
    }

    function addOption() {
        setMcq({ ...mcq, options: [...mcq.options, { id: mcq.options.length + 1, text: "", image: null }] });
        // const newMcq = { ...mcq };
        // newMcq.options.push('');
        // newMcq.correctAnswer[`${newMcq.options.length - 1}`] = false;
        // setMcq(newMcq);
        // setIsDataSaved(false);
    }

    function deleteOption(optIndex, image_key) {
        if (image_key) {
            axios.delete(`${BASEURL}/api/delete-image`, {
                data: {
                    key: image_key
                }
            })
        }
        setMcq({ ...mcq, options: mcq.options.filter((option, index) => index !== optIndex) });
        setIsDataSaved(false);
    }

    function handleSingleOrMultiple(e) {
        const newCorrectAnswer = { ...mcq.correctAnswer };
        for (let option in newCorrectAnswer) {
            newCorrectAnswer[option] = false;
        }
        setMcq({ ...mcq, type: e.target.value, correctAnswer: newCorrectAnswer });
        setIsDataSaved(false);
    }

    function handleImageUpload(event) {
        const image = event.target.files[0];
        const url = URL.createObjectURL(image);

        event.target.value = null;
        /*
            image needs to be connected with the slide imageIdArray property - store 
            keep the data in the imagesArray -- on save send the imagesArray 
        */
        setMcq({ ...mcq, imageData: { ...mcq.imageData, image: url } });
        setImagesArray((imagesArray) => {
            let newImagesArray = [...imagesArray];
            newImagesArray.push({ id: contentId, data: image });
            return newImagesArray;
        })
        setCurrentSlideData((currentSlideData) => {
            let newCurrentSlideData = { ...currentSlideData, imageIdArray: [...currentSlideData.imageIdArray, contentId] };
            return newCurrentSlideData;
        })
        setIsDataSaved(false);
    }

    function handleResize(e, d, ref, delta) {
        setMcq({ ...mcq, imageData: { ...mcq.imageData, width: ref.style.width, height: ref.style.height, } });
        setIsDataSaved(false);
    }


    function handleDeleteImage() {
        //make an api call to delete from s3 bucket 
        //on save empty the imagesArray so after that if user deletes we know to make api call
        //and if on delete the image is in array we dont make an api call we just remove from ImagesArray.
        if (!imagesArray.some(obj => obj.id === contentId)) {
            //make an api call to remove the image from s3 bucket and also remove it from mcq
            axios.delete(`${BASEURL}/api/delete-image`, {
                data: {
                    key: contentId
                }
            }).then((response) => {
                if (response.data.message === 'deleted successfully') {
                    setMcq({ ...mcq, imageData: { ...mcq.imageData, image: '', width: '400px', height: '300px' } });
                    // setCurrentSlideData((currentSlideData) => {
                    //     let newCurrentSlideData = { ...currentSlideData };
                    //     newCurrentSlideData.imageIdArray = newCurrentSlideData.imageIdArray.filter(id => id !== contentId);
                    //     return newCurrentSlideData;
                    // })
                }
            })
        } else {
            setImagesArray((imagesArray) => {
                if (imagesArray.length !== 0) {
                    const newImagesArray = imagesArray.filter((obj) => obj.id !== contentId);
                    return newImagesArray;
                }
            })
            // setCurrentSlideData((currentSlideData) => {
            //     let newCurrentSlideData = { ...currentSlideData };
            //     newCurrentSlideData.imageIdArray = newCurrentSlideData.imageIdArray.filter(id => id !== contentId);
            //     return newCurrentSlideData;
            // })
            setMcq({ ...mcq, imageData: { ...mcq.imageData, image: '', width: '400px', height: '300px' } });
        }
        setIsDataSaved(false);
    }

    const handleOptionDragEnd = (event) => {
        const { active, over } = event;

        if (!over) return; // Exit if no valid drop target.

        const activeIndex = parseInt(active.id, 10); // Convert `active.id` to integer.
        const overIndex = parseInt(over.id, 10); // Convert `over.id` to integer.

        if (activeIndex !== overIndex) {
            // Reorder the options array.
            const reorderedOptions = Array.from(mcq.options);
            const [removed] = reorderedOptions.splice(activeIndex, 1);
            reorderedOptions.splice(overIndex, 0, removed);



            // Update the state with the new order.
            setMcq((prevQuestion) => ({
                ...prevQuestion,
                options: reorderedOptions,
            }));
        }
    };

    const handleOptionImageChange = (index, newImage, uniqueId) => {
        const updatedOptions = [...mcq.options];
        updatedOptions[index] = { ...updatedOptions[index], image: newImage, imageKey: uniqueId };

        setMcq({
            ...mcq,
            options: updatedOptions,
        });
        // setCurrentSlideData((currentSlideData) => {
        //     let newCurrentSlideData = { ...currentSlideData, imageIdArray: [...currentSlideData.imageIdArray, uniqueId] };
        //     return newCurrentSlideData;
        // })
    };

    function handleAnswerTypeChange(e) {
        // single , multiple , audio
        /* 
                what did he switch to 
                switched to mcq 
                convert the input to radio 
                reset the correct answers will have to mark again 
                how are we going to make the inputs controlled 
                checked attribute takes true or false 
                correct_ansewer contains [{ checked : 'true' , value: 'answer'}] 
                single -- reset the correct_answer array and let user click on the correct 
            */
        setMcq({
            ...mcq,
            type: e.target.value,
            correctAnswer: [],
        });
        setIsDataSaved(false);
    }

    const handleUploadOptionImages = async (e, optionIndex) => {
        const file = e.target.files[0];
        if (file) {
            const uniqueId = uuidv4();
            const formData = new FormData();
            formData.append('image', file);
            formData.append('id', uniqueId);
            const response = await axios.post(`${BASEURL}/api/upload-image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            const imageResponseObject = await axios.get(`${BASEURL}/api/get-image`, {
                params: {
                    imageId: uniqueId,
                }
            })
            const reader = new FileReader();
            reader.onloadend = () => {
                handleOptionImageChange(optionIndex, imageResponseObject.data.dataUrl, uniqueId); // Set the image as a base64 string
            };
            reader.readAsDataURL(file);
        }
    }

    const handleDeleteOptionImage = (optionIndex, image_key) => {

        if (image_key) {
            axios.delete(`${BASEURL}/api/delete-image`, {
                data: {
                    key: image_key
                }
            })
            let newOption = mcq.options.map((option, index) => {
                if (optionIndex === index) {
                    return { ...option, imageKey: "", image: null }
                } else {
                    return option
                }
            })
            setCurrentSlideData((currentSlideData) => {
                let newCurrentSlideData = { ...currentSlideData };
                newCurrentSlideData.imageIdArray = newCurrentSlideData.imageIdArray.filter(id => id !== image_key);
                return newCurrentSlideData;
            })
            setMcq({ ...mcq, options: newOption })
        }

    }

    const handleOnChange = (option) => {
        // Handle correct answer change
        setMcq((prev) => {
            let updatedCorrectAnswers = [...prev.correctAnswer];

            if (prev.type === "single") {
                updatedCorrectAnswers = [{ checked: true, value: option.id }];
            } else if (prev.type === "multiple") {
                const existingIndex = updatedCorrectAnswers.findIndex(
                    (answer) => answer.value === option.id
                );
                if (existingIndex !== -1) {
                    updatedCorrectAnswers.splice(existingIndex, 1); // Remove if already selected
                } else {
                    updatedCorrectAnswers.push({
                        checked: true,
                        value: option.id,
                    });
                }
            }

            return {
                ...prev,
                correctAnswer: updatedCorrectAnswers,
            };
        });

        setIsDataSaved(false);
    }

    return (
        <>
            {
                mcq &&
                <div key={contentId} className="p-6 bg-[#F1F3F6]">
                    <div className="mb-4 flex items-center text-sm">
                        <input checked={mcq.type === 'single'} className="mr-2" id="single" value={'single'} type="radio" name={contentId}
                            onChange={handleAnswerTypeChange} />
                        <label className="mr-4" htmlFor="single">Single correct</label>

                        <input checked={mcq.type === 'multiple'} className="mr-2 " id="multiple" value={'multiple'} type="radio" name={contentId} onChange={handleAnswerTypeChange} />

                        <label htmlFor="multiple">Multiple correct</label>
                    </div>
                    {/* <textarea className="w-full mb-1 border p-2 text-xs outline-none" rows={3} type="text" placeholder="Enter your question" value={mcq.question} onChange={(e) => { updateQuestion(e) }} ></textarea> */}
                    <QuestionEditor key={contentId} data={mcq.text} setQuestion={setMcq} setIsDataSaved={setIsDataSaved} />


                    <div className="flex justify-between items-center mb-2">
                        {
                            mcq?.imageData?.image ? (
                                <div className="w-4/5 flex gap-2 justify-start p-2">
                                    {/* a bit of styling remaining here */}
                                    <Resizable
                                        size={{
                                            width: mcq.imageData.width,
                                            height: mcq.imageData.height
                                        }}
                                        maxWidth='100%'
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                        lockAspectRatio={false}
                                        onResizeStop={(e, d, ref, delta) => handleResize(e, d, ref, delta)}
                                    >
                                        <img src={mcq?.imageData?.image} style={{ height: "100%", width: "100%" }}></img>
                                    </Resizable>
                                    <i style={{ cursor: 'pointer' }} onClick={handleDeleteImage} className="fa-regular fa-circle-xmark"></i>
                                </div>) : (
                                <div className={`border-2 border-dashed p-2`}>
                                    <label className="flex gap-2 items-center cursor-pointer text-gray-500 text-xs" htmlFor={`mcq-image${contentId}`}> <AddImageSVG /> <span className="font-bold text-xs">Add Image</span></label>
                                    <input type='file' accept='image/*' id={`mcq-image${contentId}`} onChange={(event) => handleImageUpload(event)} style={{ display: "none" }}></input>
                                </div>
                            )
                        }

                        {/* <select className="text-xs" style={{ marginLeft: '22px', marginTop: '10px' }} onChange={handleSingleOrMultiple} value={mcq.type}>
                            <option value={"single"}>Single correct</option>
                            <option value={"multiple"}>Multiple correct</option>
                            <option value={"audio"}>Audio</option>
                        </select> */}
                    </div>
                    {/* {
                        mcq.imageData.image ? (
                            
                        ) : null
                    } */}

                    <div className="text-xs grid grid-cols-2 gap-4"
                    // style={{
                    //     display: 'grid',
                    //     gridTemplateColumns: 'auto auto',
                    //     gridTemplateRows: `repeat(${Math.ceil((mcq.options.length) / 2)}, 80px)`,
                    //     gap: '0.5rem'
                    // }}
                    >
                        {/* {
                            mcq.type === "single" ? (
                                mcq.options.map((option, optionIndex) => {
                                    return (
                                        <div key={optionIndex} className="flex gap-2 border border-solid h-10 border-gray-300 items-center px-0 py-0 bg-white"
                                        // style={{ display: 'flex', gap: '5px', border: '1px solid #6b7280', alignItems: 'center', padding: '0rem 0.5rem', borderRadius: '0.5rem' }}
                                        >
                                            <span className="flex items-center py-2 px-3 border-r border-solid border-gray-300 h-full text-sm text-[#4F4F4F]">{`${String.fromCharCode(65 + optionIndex)}`}</span>
                                            <input className="text-xl" type="radio" value={option} checked={mcq.correctAnswer[`${optionIndex}`]} name="radio" onChange={(e) => { saveCorrectAnswer(e, optionIndex) }} />

                                            <input className="grow outline-none text-xs" type="text" placeholder={`Answer ${optionIndex + 1}`} value={option} onChange={(e) => { saveOption(e, optionIndex) }} />
                                            <div className="border-l p-2 h-full flex items-center  justify-center" onClick={() => { deleteOption(optionIndex) }}><CrossSVG /></div>
                                        </div>
                                    )
                                })) : (
                                mcq.options.map((option, optionIndex) => {
                                    return (
                                        <div className="flex gap-2 border border-solid h-10 border-gray-300 items-center px-0 py-0 bg-white" key={optionIndex}>
                                            <span className="flex items-center py-2 px-3 border-r border-solid border-gray-300 h-full text-sm text-[#4F4F4F]">{`${String.fromCharCode(65 + optionIndex)}`}</span>
                                            <input type="checkbox" value={option} checked={mcq.correctAnswer[`${optionIndex}`]} disabled={!option} name="radio" onChange={(e) => { saveCorrectAnswer(e, optionIndex) }} />

                                            <input type="text" className="grow outline-none text-xs" placeholder={`Answer ${optionIndex + 1}`} value={option} onChange={(e) => { saveOption(e, optionIndex) }} />
                                            <div className="border-l p-2 h-full flex items-center justify-center" onClick={() => { deleteOption(optionIndex) }}><CrossSVG /></div>
                                        </div>
                                    )
                                }
                                ))
                        } */}

                        <DndContext
                            collisionDetection={closestCenter}
                            onDragEnd={handleOptionDragEnd} // Handle the drag end event for options
                        >
                            <SortableContext
                                items={mcq.options.map((_, index) =>
                                    index.toString()
                                )}
                                strategy={rectSortingStrategy}
                            >

                                {
                                    mcq.type === "single" || mcq.type === "multiple"
                                        ?
                                        mcq.options.map((option, optionIndex) => {

                                            const isChecked = mcq?.correctAnswer?.some(
                                                (answer) => answer.value === option.id
                                            );
                                            return (
                                                <TopicSortableItem
                                                    key={optionIndex}
                                                    id={optionIndex.toString()}
                                                >
                                                    <div className="w-full">
                                                        <div key={`${contentId}-${optionIndex}`} className="flex gap-2 w-full border border-solid h-10 border-gray-300 items-center px-0 py-0 bg-white">
                                                            <span className="flex items-center py-2 px-3 border-r border-solid border-gray-300 h-full text-sm text-[#4F4F4F]">
                                                                {`${String.fromCharCode(65 + optionIndex)}`}
                                                            </span>

                                                            {/* Radio or Checkbox */}
                                                            {/* {mcq.type === "single" ? (
                                                        <input
                                                            className="text-xl"
                                                            type="radio"
                                                            value={option}
                                                            checked={mcq.correctAnswer[optionIndex]}
                                                            name={`${contentId}radio`}
                                                            onChange={(e) => saveCorrectAnswer(e, optionIndex)}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="checkbox"
                                                            value={option}
                                                            checked={mcq.correctAnswer[optionIndex]}
                                                            disabled={!option}
                                                            name={`${contentId}checkbox`}
                                                            onChange={(e) => saveCorrectAnswer(e, optionIndex)}
                                                        />
                                                    )} */}

                                                            <input
                                                                key={`${contentId}${optionIndex}`}
                                                                className="text-xl"
                                                                type={mcq.type === "single" ? "radio" : "checkbox"}
                                                                disabled={!option.text}
                                                                value={option.id}
                                                                checked={isChecked}
                                                                name={`${contentId}-answer`}
                                                                onChange={() => {
                                                                    handleOnChange(option)
                                                                }}
                                                            />

                                                            {/* Input for Option Text */}
                                                            <input
                                                                className="grow outline-none text-xs"
                                                                type="text"
                                                                placeholder={`Answer ${optionIndex + 1}`}
                                                                value={option.text}
                                                                onChange={(e) => saveOption(e, optionIndex)}
                                                            />

                                                            {/* Image upload icon */}
                                                            <div className="cursor-pointer pl-2 mr-1 border-l border-solid border-gray-300 h-[40px] flex items-center">
                                                                <label htmlFor={`image-upload-${optionIndex}${contentId}`}>
                                                                    <i className="fa-regular fa-image text-lg"></i>
                                                                </label>
                                                                <input
                                                                    key={`${optionIndex}${contentId}`}
                                                                    type="file"
                                                                    id={`image-upload-${optionIndex}${contentId}`}
                                                                    accept="image/*"
                                                                    style={{ display: "none" }}
                                                                    onChange={(e) =>
                                                                        handleUploadOptionImages(e, optionIndex)
                                                                    }
                                                                />
                                                            </div>

                                                            {/* Delete Option Button */}
                                                            <div
                                                                className="border-l p-2 h-full flex items-center justify-center"
                                                                onClick={() => deleteOption(optionIndex, option.imageKey)}
                                                            >
                                                                <CrossSVG />
                                                            </div>
                                                        </div>
                                                        {option.image && (
                                                            <>
                                                                <div key={contentId} className="relative mt-2 h-24 w-24 border border-solid border-gray-300 overflow-hidden">
                                                                    <i
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => handleDeleteOptionImage(optionIndex, option.imageKey)}
                                                                        className="fa-regular fa-circle-xmark absolute top-0 right-0 text-red-500 text-lg"
                                                                    ></i>
                                                                    <div className="flex items-center justify-center h-full w-full">
                                                                        <img
                                                                            key={contentId}
                                                                            src={option.image}
                                                                            alt={`Option ${optionIndex}`}
                                                                            className="w-full h-full object-contain p-[px]"
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </>
                                                        )}
                                                    </div>
                                                </TopicSortableItem>
                                            )
                                        })


                                        : null}
                            </SortableContext>
                        </DndContext>

                    </div>
                    <div className="flex">
                        <button className="py-4 flex items-center justify-center text-[#1F1A4C] text-sm" onClick={addOption}>
                            <PlusSVG color='purple' />
                            Add option
                        </button>
                    </div>
                </div>

            }
        </>
    );
}

export default McqComponent;